import React from "react";
import { useState } from "react";
import bankService from "../../../../Services/apiService/bank-service";
import { useAuth } from "../../../../Utils/Auth";
import { toast } from "react-toastify";
import { customErrorHandler, toTitleCase } from "../../../../Utils/helper";
import AddWithdraw from "../../../../Component/deposit_Withdraw_Dialog/index";
const AddBankBalance = ({
  state,
  setState,
  renderParent,
  setPage,
  handleClose
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const initialFormData = {
    amount : 0 ,
    remarks : ''
  }
const [formData , setFormData] = useState(initialFormData)
  const auth = useAuth();

  const handleDialogClose = () => {
  setFormData(initialFormData);
  handleClose();
};

  const handelsubmit = (e) => {
    e.preventDefault();
    if (formData.amount === 0 || formData.remarks === "" || formData.amount < 0) {
      if (formData.amount < 0) {
        toast.error(toTitleCase("amount can not be negetive"));
        return;
      }
      toast.error(toTitleCase("amount and remakrs fields cannot be empty."));
      return;
    }
    setIsLoading(true);
    const data = {
      amount: Number(formData.amount),
      transactionType: "Manual-Bank-Deposit",
      remarks: formData.remarks,
    };

    bankService
      .manualBankEntryDeposit(state.data, data, auth.user)
      .then((res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          toast.success(toTitleCase(res?.data?.message));
          // setPage(1); // beacuse now user can find the same in first page only (commented beacuse business logic changed)
          renderParent(res);
          handleDialogClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(toTitleCase(customErrorHandler(error)));
      });
  };

  return (
    <React.Fragment>
      <AddWithdraw
        title={"Bank Deposit"}
        formData = {formData}
        setFormData = {setFormData}
        isLoading={isLoading}
        handelSubmit={handelsubmit}
        userName = {auth.user.userName}
        dilaogShow={state.show}
        handleClose = {handleDialogClose}
      />
    </React.Fragment>
  );
};

export default React.memo(AddBankBalance);
